import { Flex } from '@aloft/toolkit-sui';

import React, { useState } from 'react';

import { useTkv2ReferenceBarEvents } from '../../components/ReferenceBar/useTkv2ReferenceBarEvents.ts';
import { AnalysisGrid } from './ModuleComponents/AnalysisGrid.tsx';
import { AnalysisToolbar } from './ModuleComponents/AnalysisToolbar.tsx';
import { ViewMode } from './types.ts';

import './AnalysisModule.scss';

export const AnalysisModule = React.memo(() => {
  const [viewMode, setViewMode] = useState<ViewMode>('cost');

  return (
    <Flex
      {...useTkv2ReferenceBarEvents()}
      className="analysis-module"
      width="100%"
      gap={2}
      paddingLeft="1.5rem"
    >
      <AnalysisToolbar viewMode={viewMode} setViewMode={setViewMode} />
      <AnalysisGrid viewMode={viewMode} />
    </Flex>
  );
});
